import React from "react";
import "../styles/VideoCardOverlay.css";
import { handleImageErrorCallBack } from "../../recommendation/recommendation_industry_view/components/ErrorImage_PlaceHolder";
import checkedStatus from "../assets/images/completetick.png";
import newImg from "../../recommendation/assets/images/common/new_img.png";
import playButton from "../assets/images/playInfo.png";
import CommonUtils from "../../../utils/Common_Utils";
import pdfIcon from "../assets/images/pdfIcon.png";
interface VideoCardProps {
  title: string;
  videoUrl: string;
  newFlag?: boolean;
  width?: string;
  height?: string;
  playBtnheight?: string;
  playBtnwidth?: string;
  // completed?: boolean;
  // isDocument?: boolean;
  // active?: boolean;
  content_type: string | null | undefined;
  completionStatus: string;
  postedonDate: string;
  onClick?: () => void;
}
const VideoCard: React.FC<VideoCardProps> = ({
  title,
  videoUrl,
  newFlag = false,
  width = "100%",
  height = "150px",
  playBtnheight = "43px",
  playBtnwidth = "56px",
  completionStatus,
  // isDocument = false,
  postedonDate,
  onClick,
  content_type,
}) => {
  return (
    <div
      className={`video-card ${completionStatus === "Completed" ? "completed" : completionStatus === "In Progress" ? "inprogress" : ""}`}
      onClick={onClick}
    >
      <div className="thumbnail-container" style={{ width, height }}>
        <img
          src={videoUrl}
          alt={title}
          className="thumbnail"
          style={{
            width: "100%",
            height: "100%",
            cursor: onClick ? "pointer" : "default",
          }}
          onClick={onClick}
          onError={(e) => handleImageErrorCallBack(e, width, height, onClick)}
        />

        {content_type === "video" && (
          <div
            style={{
              width: playBtnwidth,
              height: playBtnheight,
            }}
          >
            <img
              src={playButton}
              alt="Overlay"
              style={{
                position: "absolute",
                cursor: "pointer",
                top: "35%",
                left: "50%",
                width: playBtnwidth,
                height: playBtnheight,
                transform: "translate(-50%, -50%)", // Center the image
              }}
              onClick={onClick}
            />
          </div>
        )}

        {content_type === "pdf" && (
          <div
            className="center-icon"
            style={{
              width: playBtnwidth,
              height: playBtnheight,
            }}
          >
            <img
              src={pdfIcon}
              alt="Overlay"
              style={{
                position: "absolute",
                cursor: "pointer",
                // top: "50%",
                left: "50%",
                width: "45px",
                // width: playBtnwidth,
                // height: playBtnheight,
                transform: "translate(-50%, -50%)", // Center the image
              }}
              onClick={onClick}
            />
          </div>
        )}

        {completionStatus === "Completed" && (
          <div className="completed-badge">
            <img className="completed-badge-img" src={checkedStatus} />
          </div>
        )}

        {newFlag && (
          <img
            src={newImg}
            alt="Overlay"
            style={{
              position: "absolute",
              top: "8px", // Adjust to position
              right: "8px", // Adjust to position
              width: "30px",
              height: "20px",
            }}
          />
        )}
      </div>

      <p className="video-title">{title}</p>
      {/* <p style={{ fontSize: "0.8rem" }} className="image-child">
        Posted on {CommonUtils.formatAllRegionDate(postedonDate)}
      </p> */}
    </div>
  );
};
export default VideoCard;
